import { useAuthQuery } from "@/common/api/services/auth";
import { useAuth } from "@/common/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { DeleteUserDialog } from "@/modules/Users/components/DeleteUserDialog";

export const DeleteAccountSection = () => {
    const { t } = useTranslation();
    const { profileQuery } = useAuthQuery();

    // Отримуємо дані поточного користувача
    const { data: user } = useQuery(profileQuery);

    // Функція для перенаправлення після видалення акаунту
    const handleDeleteSuccess = () => {
        // Виходимо з системи після деактивації акаунту
        setTimeout(() => {
            // Очищуємо localStorage і перенаправляємо на сторінку логіну
            localStorage.clear();
            window.location.href = '/auth/login';
        }, 1500);
    };

    if (!user) return null;

    return (
        <Card className="border-destructive/50">
            <CardHeader>
                <CardTitle className="text-destructive-foreground">
                    {t("settings.deleteAccount.title")}
                </CardTitle>
                <CardDescription>
                    {t("settings.deleteAccount.description")}
                </CardDescription>
            </CardHeader>
            <CardContent>
                <p className="text-sm text-muted-foreground">
                    {t("settings.deleteAccount.warning")}
                </p>
            </CardContent>
            <CardFooter>
                <DeleteUserDialog
                    user={user}
                    isSelfDelete={true}
                    onSuccess={handleDeleteSuccess}
                    trigger={
                        <Button
                            variant="destructive"
                            className="w-full"
                        >
                            <Trash2 className="mr-2 h-4 w-4" />
                            {t("settings.deleteAccount.action")}
                        </Button>
                    }
                />
            </CardFooter>
        </Card>
    );
}; 